package com.cybersoftsolution.cybersoftsolutionweb.models

import com.cybersoftsolution.cybersoftsolutionweb.models.Values.CONFIG_ID_DEFAULT_VALUE
import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
actual data class ConfigResponse(
    actual var isProductionMode: Boolean? = null,
    actual var emailSenders: List<String>? = emptyList(),
    actual var emailSender: String? = null,
    actual var otpExpirationTimeInMin: Long? = null,
)



